export default __webpack_public_path__ + "static/media/notfound.21f31625.png";